import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../hook/use-http";
import * as $ from "jquery";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "moment/locale/en-gb";
import { differenceInDays } from "date-fns";
import "./rcaaceCustom.css";
import DashboardMain from "../DashboardMain/DashboardMain";
import RcaTableAce from "./RcaAceTable";
import RcaAceToggler from "./RcaAceToggler";
import RcaAceChart from "./RcaAceChart";
import RcaAceChartB from "./RcaAceChartB";
import RcaAceChartC from "./RcaAceChartC";
import {
  BsFillArrowLeftSquareFill,
  BsFillArrowRightSquareFill,
} from "react-icons/bs";

export default function ACERcaNew() {
  // const [country, setCountry] = useState(null);
  // const [langList, setLangList] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();

  // const [firstOption, setFirstOption] = useState("")

  const [startDate, setStartDate] = useState(
    moment().subtract(8, "days").startOf("day")._d
  );
  const [startDate1, setStartDate1] = useState(
    moment().subtract(15, "days").startOf("day")._d
  );
  const [endDate, setEndDate] = useState(
    moment().subtract(1, "days").endOf("day")._d
  );
  const [endDate1, setEndDate1] = useState(
    moment().subtract(1, "days").endOf("day")._d
  );
  const [vinNumber, setVinNumber] = useState("");
  const { chasis } = useParams();

  useEffect(() => {
    if (chasis) {
      setVinNumber(chasis);
    }
  }, [chasis]);

  const vinNumChanged = (e) => {
    setVinNumber(e.target.value);
  };

  const log_data = (data) => {
    //  console.log(data);
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "RCA_ace",
        },
      },
      log_data
    );
  }, []);

  // // code copied from cgarging page
  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  };
  // const [type, setType] = useState("tml_cv_ev_stg_staging_can")
  const [filterObject, setFilterObject] = useState({
    start_date: startDate,
    end_date: endDate,
    vin_no: "",
  });
  const [emptyMultiVinError, setEmptyMultiVinError] = useState("");
  const [emptyTypeError, setEmptyTypeError] = useState("");
  const [daysGreterSeven, setdaysGreterSeven] = useState("");

  const filterChanged = (e) => {
    e.preventDefault();
    if (vinNumber.trim() === "") {
      setEmptyMultiVinError("Please enter a Vin Number");
    } else if (vinNumber.split(",").length > 1) {
      setEmptyMultiVinError("Please enter a single Vin Number");
    } else {
      // setFilterObject({ "start_date": startDate, "end_date": endDate, "vin_no": vinNumber })
      const diff = differenceInDays(endDate, startDate);
      if (diff < 7) {
        setdaysGreterSeven("");
        setEmptyMultiVinError("");
        setFilterObject({
          start_date: startDate,
          end_date: endDate,
          vin_no: vinNumber,
        });
      } else {
        setdaysGreterSeven("Select 7 days Range");
      }
    }
  };

  const reset = (e) => {
    e.preventDefault();
    window.location.reload(true);
  };

  const [activePage, setActivePage] = useState(1);
  const [isOpened, setIsOpened] = useState(false);
  const [isOpenedC, setIsOpenedC] = useState(false);
  const [commanHideShow, setCommanHideShow] = useState("1st");
  const FirstButtonClick = () => {
    setCommanHideShow("1st");
    setActivePage(1);
  };
  const SecondButtonClick = () => {
    setCommanHideShow("2nd");
    setActivePage(2);
    if (!isOpened) {
      setIsOpened(true);
    }
  };
  const ThirdButtonClick = () => {
    setCommanHideShow("3nd");
    setActivePage(3);
    if (!isOpenedC) {
      setIsOpenedC(true);
    }
  };

  const [drawerToggler, setDrawerToggler] = useState(true);
  const drawerTogglerClick = () => {
    drawerToggler ? setDrawerToggler(false) : setDrawerToggler(true);
  };

  const [dataChoosedA, setDataChoosedA] = useState([]);
  const [dataChoosedB, setDataChoosedB] = useState([]);
  const [dataChoosedC, setDataChoosedC] = useState([]);
  const userSelectedData = (dropdownData, grupName) => {
    if (grupName === "A") {
      setDataChoosedA(dropdownData);
    } else if (grupName === "B") {
      setDataChoosedB(dropdownData);
    } else {
      setDataChoosedC(dropdownData);
    }
  };

  return (
    <>
      <DashboardMain>
        <div className="container-fluid aisMainDiv">
          <div className="text-end">
            <button
              type="button"
              id="filterIcon"
              className="btn btn-outline-primary material-icons ev_filter_icon"
              onClick={filterHideShow}
            >
              filter_alt
            </button>
          </div>
          <div
            className="aisFilterDiv pt-2 mt-1"
            id="filterSearch"
            style={{ display: "block", zIndex: 1 }}
          >
            <form className="row g-3 mt-2 aisFilterForm justify-content-center">
              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label"
                    >
                      Start Date &amp; Time
                    </label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      timeInputLabel="Time:"
                      dateFormat="dd-MM-yyyy h:mm aa"
                      timeFormat="HH:mm"
                      showTimeInput
                      minDate={startDate1}
                      maxDate={endDate1}
                    />
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label
                      htmlFor="exampleFormControlInput2"
                      className="form-label"
                    >
                      End Date &amp; Time
                    </label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      timeInputLabel="Time:"
                      dateFormat="dd-MM-yyyy h:mm aa"
                      timeFormat="HH:mm"
                      showTimeInput
                      minDate={startDate1}
                      maxDate={endDate1}
                    />
                    <p
                      className="text-danger text-left forDayError"
                      style={{ fontSize: "12px" }}
                    >
                      <b>{daysGreterSeven}</b>
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <label
                    htmlFor="exampleFormControlInput2"
                    className="form-label"
                  >
                    Chassis No / Reg No
                  </label>
                  <input
                    autoComplete="off"
                    className="top-filterARAI filter-col"
                    placeholder="Chassis No / Reg No"
                    id="vin_num"
                    name="vin_num"
                    onChange={vinNumChanged}
                    value={vinNumber}
                  />
                  <p
                    className="text-danger text-left"
                    style={{ fontSize: "12px" }}
                  >
                    <b>{emptyMultiVinError}</b>
                  </p>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="mt-3">
                          <label className="form-label" />
                          <button
                            className="form-control btn btn-primary"
                            type="submit"
                            onClick={filterChanged}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="mt-3">
                          <label className="form-label" />
                          <button
                            type="submit"
                            onClick={reset}
                            className="form-control btn btn-secondary"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <section className="highlights">
          <div className="row mt-3">
            <RcaTableAce filterObject={filterObject} />
            <div
              className="col-md-3 col-sm-3 col-lg-3 mb-3 pr-0"
              style={{
                display: drawerToggler ? "block" : "none",
                paddingLeft: "20px",
              }}
            >
              <div className="rcaBoxes p-2">
                <div className="paginationRcaAce">
                  <button
                    onClick={FirstButtonClick}
                    className={activePage === 1 ? "active" : ""}
                  >
                    1
                  </button>
                  <button
                    onClick={SecondButtonClick}
                    className={activePage === 2 ? "active" : ""}
                  >
                    2
                  </button>
                  <button
                    onClick={ThirdButtonClick}
                    className={activePage === 3 ? "active" : ""}
                  >
                    3
                  </button>
                  <h1
                    onClick={drawerTogglerClick}
                    className="justify-content-start d-flex h1TogglerButtonAce"
                    align="center"
                  >
                    {drawerToggler ? (
                      <BsFillArrowLeftSquareFill />
                    ) : (
                      <BsFillArrowRightSquareFill />
                    )}
                  </h1>
                </div>
                <RcaAceToggler
                  filterObject={filterObject}
                  commanHideShow={commanHideShow}
                  userSelectedData={userSelectedData}
                />
              </div>
            </div>
            <div
              className={
                drawerToggler
                  ? "col-md-9 col-sm-9 col-lg-9 mb-3"
                  : "col-md-12 col-sm-12 col-lg-12 mb-3"
              }
            >
              <div className="rcaBoxes">
                {!drawerToggler && (
                  <h1
                    onClick={drawerTogglerClick}
                    className="justify-content-start d-flex h1TogglerButtonAce"
                    align="center"
                  >
                    {drawerToggler ? (
                      <BsFillArrowLeftSquareFill />
                    ) : (
                      <BsFillArrowRightSquareFill />
                    )}
                  </h1>
                )}
                <RcaAceChart
                  id="chartdiv1"
                  filterObject={filterObject}
                  dataChoosedA={dataChoosedA}
                />
                {isOpened ? (
                  <RcaAceChartB
                    id="chartdiv2"
                    filterObject={filterObject}
                    dataChoosedB={dataChoosedB}
                  />
                ) : null}
                {isOpenedC ? (
                  <RcaAceChartC
                    id="chartdiv3"
                    filterObject={filterObject}
                    dataChoosedC={dataChoosedC}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </section>
      </DashboardMain>
    </>
  );
}
